import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import MobileSearchBox from './MobileSearchBox';
import ListToggle from './ListToggle';
import TopicsList from './TopicsList';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    background: '#fff',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  searchWrapper: {
    paddingLeft: 16,
    paddingRight: 16,
    marginTop: 45,
    marginBottom: 30,
    '& > form': {
      border: '1px solid #EFEFEF',
    },
  },
  closeIcon: {
    position: 'absolute',
    left: 10,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MobileTopicsDialog(props) {
  const {
    themes,
    selectedTopic,
    searchTopic,
    isSearching,
    filteredTopicsList,
    changeFilter,
    withSearch,
    withBorder,
  } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const selectTopic = (slug, event, type, id) => {
    setOpen(false);
    changeFilter(slug, event, type, id);
  };

  return (
    <div>
      <MobileSearchBox
        clickHandler={handleClickOpen}
        value={selectedTopic}
        searchTopic={searchTopic}
        withSearch={withSearch}
        withBorder={withBorder}
      />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          className={classes.closeIcon}
        >
          <CloseIcon />
        </IconButton>
        <div className={classes.searchWrapper}>
          <MobileSearchBox
            clickHandler={handleClickOpen}
            value={selectedTopic}
            searchTopic={searchTopic}
          />
        </div>
        {!isSearching ? (
          <ListToggle data={themes} changeFilter={selectTopic} />
        ) : (
          <TopicsList
            topics={filteredTopicsList}
            selectTopic={selectTopic}
            isSearching={isSearching}
          />
        )}
      </Dialog>
    </div>
  );
}

MobileTopicsDialog.propTypes = {
  themes: PropTypes.array,
  changeFilter: PropTypes.func,
  selectedTopic: PropTypes.string,
  searchTopic: PropTypes.func,
  isSearching: PropTypes.bool,
  filteredTopicsList: PropTypes.array,
  withSearch: PropTypes.bool,
  withBorder: PropTypes.bool,
};

MobileTopicsDialog.defaultProps = {
  withSearch: true,
  withBorder: false,
};

export default MobileTopicsDialog;
